const routes = [
  {
    path: "/manutencao-promotor-x-curso",
    name: "manutencao-promotor-x-curso",
    meta: {
      allowedPermissions: ["promotores_x_cursos_list"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDePromotorXCurso/ManutencaoDePromotorXCursoHome.vue"
      ),
  },
  {
    path: "/manutencao-promotor-x-curso/novo",
    name: "manutencao-promotor-x-curso-novo",
    meta: {
      allowedPermissions: ["promotores_x_cursos_insert"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDePromotorXCurso/ManutencaoDePromotorXCursoCad.vue"
      ),
  },
  {
    path: "/manutencao-promotor-x-curso/editar/:id",
    name: "manutencao-promotor-x-curso-editar",
    meta: {
      allowedPermissions: ["promotores_x_cursos_update"],
      breadCrumb: "Lotação de Servidores - Tabelas Básicas",
    },
    component: () =>
      import(
        "@/views/ManutencaoDePromotorXCurso/ManutencaoDePromotorXCursoEdit.vue"
      ),
  },
];

export default routes;
